module.exports = __webpack_public_path__ + "static/media/flooring_gwp_10y_n.66ba4db3.csv";